import * as PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'reactstrap'

import mail from '../../../ressurser/icons/mail.svg'
import { EPOST_BESTILL_RAPPORT } from '../../../ressurser/Konstanter'
import selectStandardrapporter from '../redux/selectors'

import LastNedRapport from './LastNedRapport'

import './rapportListe.css'

class Rapportliste extends React.PureComponent {
    static bestillRapport(rapporttype, arBehandlet, fylkeBehandlet, kommuneBehandlet) {
        const bodyTekst = `Trine: Vennligst lag følgende rapport: ${rapporttype} for år: ${arBehandlet}, fylke: ${fylkeBehandlet}, kommune: ${kommuneBehandlet}, `
        const emne = `Trine: Opprett standardrapport ${rapporttype} for ${arBehandlet}, i ${fylkeBehandlet}, ${kommuneBehandlet}`
        document.location.href =
            'mailto:' +
            EPOST_BESTILL_RAPPORT +
            '?subject=' +
            encodeURIComponent(emne) +
            '&body=' +
            encodeURIComponent(bodyTekst)
    }

    finnArFylkeKommuneFraSokeresultat() {
        const { standardrapporter } = this.props
        const { ar, fylke, kommune } = standardrapporter

        const arBehandlet = (ar && ar.label) || ''
        const fylkeBehandlet = (fylke && fylke.label && fylke.label.split('- ')[1]) || 'Alle'
        const kommuneBehandlet = (kommune && kommune.label && kommune.label.split('- ')[1]) || 'Alle'

        return { ar: arBehandlet, fylke: fylkeBehandlet, kommune: kommuneBehandlet }
    }

    erEnEllerFlereRapporterAktivertITrine(rapportListe) {
        return Object.values(rapportListe).some((rapportConfig) => rapportConfig.aktivertITrine)
    }

    render() {
        const { overskrift, rapportliste, standardrapporter, sokUtfort } = this.props
        const { tilgjengeligeRapporter } = standardrapporter

        const { ar, fylke, kommune } = this.finnArFylkeKommuneFraSokeresultat()

        if (!this.erEnEllerFlereRapporterAktivertITrine(rapportliste)) {
            return null
        }

        const rapporter = Object.values(rapportliste).map((rapportConfig) => {
            const fikkTreffPaSok = tilgjengeligeRapporter.includes(rapportConfig.tekniskNavn)
            if (!rapportConfig.aktivertITrine) return null
            // TODO: ikke aria live polite, men sett fokus til overskrift
            return (
                <React.Fragment key={rapportConfig.tekniskNavn}>
                    <Row style={{ marginLeft: 0 }}>
                        <Col>
                            <div aria-live="polite">
                                <h3 style={{ fontSize: '1.3rem' }}>{rapportConfig.visningsnavn}</h3>
                                {!sokUtfort && (
                                    <p>
                                        <i>Du må utføre et søk for å få tilgang til rapporter.</i>
                                    </p>
                                )}
                                {sokUtfort && fikkTreffPaSok && (
                                    <LastNedRapport rapportConfig={rapportConfig} ar={ar} fylke={fylke} kommune={kommune} />
                                )}
                                {sokUtfort && !fikkTreffPaSok && (
                                    <ul className="bestill-rapport-lenke-liste mb-4">
                                        <li>
                                            <a
                                                className="editorial-link"
                                                href="#"
                                                aria-label={
                                                    'Bestill ' +
                                                    rapportConfig.visningsnavn +
                                                    ' via e-post. Åpner e-post klient.'
                                                }
                                                onClick={() => {
                                                    Rapportliste.bestillRapport(rapportConfig.tekniskNavn, ar, fylke, kommune)
                                                }}
                                            >
                                                Bestill {rapportConfig.visningsnavn}
                                                <span>
                                                    {' '}
                                                    <img src={mail} alt="Mail" />
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        })

        return (
            <Col lg={5} className="rapportlister">
                <div className="mb-3 mt-3">
                    <h2 className="heading-decoration">{overskrift}</h2>
                    {rapporter}
                </div>
                <br />
            </Col>
        )
    }
}

Rapportliste.propTypes = {
    sokUtfort: PropTypes.bool.isRequired,
    overskrift: PropTypes.string.isRequired,
    rapportliste: PropTypes.object.isRequired,
    standardrapporter: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
    standardrapporter: selectStandardrapporter(state)
})

export default connect(mapStateToProps)(Rapportliste)
